import * as React from 'react';

export interface IListTableColumnProps<T = any> {
  column: string;
  source?: string | string[];
  excelSource?: string;
  label?: string;
  sortable?: boolean;
  value?: any;
  showDefault?: boolean;
  ignoreOnExcel?: boolean;
  tdProps?: React.DetailedHTMLProps<
    React.TdHTMLAttributes<HTMLTableDataCellElement>,
    HTMLTableDataCellElement
  >;
  settingsGroup?: string;
  formatContent?: (value?: any) => React.ReactNode | undefined;
  nullContent?: React.ReactNode;
  onClick?: (rowData: T, index: number, value: any) => void;
  sortKey?: string;
  fixed?: boolean;
  fixedPosition?: 'start' | 'end';
  anotherValue?: string;
  anotherSource?: string;
  cssClass?: string;
  diableClick?: boolean;
}

const ListTableColumn: React.FunctionComponent<IListTableColumnProps> = (
  props
) => {
  const value: any = props.value?.length || 0;

  return <>{value}</>;
};

export default ListTableColumn;
